import db from '@/utils/localstorage'

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get('THEME', 'light'),
    layout: db.get('LAYOUT', 'side'),
    // eslint-disable-next-line no-undef
    systemName: isRLZY ? GlobUrl.systemName.rlzy : GlobUrl.systemName.jiebao,
    copyright: `${new Date().getFullYear()} <a href="#" target="_blank" style="color:#fff;font-weight:bold;">JIEBAO </a><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#fff;font-weight:bold;"> 湘ICP备2024050664号-1</a>`,
    multipage: getBooleanValue(db.get('MULTIPAGE'), true),
    fixSiderbar: getBooleanValue(db.get('FIX_SIDERBAR'), true),
    fixHeader: getBooleanValue(db.get('FIX_HEADER'), true),
    colorList: [
      'rgb(245, 34, 45)',
      'rgb(250, 84, 28)',
      'rgb(250, 173, 20)',
      'rgb(66, 185, 131)',
      'rgb(82, 196, 26)',
      'rgb(24, 144, 255)',
      'rgb(47, 84, 235)',
      'rgb(114, 46, 209)'
    ],
    fontFamilyList: [
      {name: '默认', value: ''},
      { name: '宋体', value: 'SimSun' },
      { name: '黑体', value: 'SimHei' },
      { name: '微软雅黑', value: 'Microsoft YaHei' },
      { name: '微软正黑体', value: 'Microsoft JhengHei' },
      { name: '新宋体', value: 'NSimSun' },
      { name: '新细明体', value: 'PMingLiU' },
      { name: '细明体', value: 'MingLiU' },
      { name: '标楷体', value: 'DFKai-SB' },
      { name: '仿宋', value: 'FangSong' },
      { name: '楷体', value: 'KaiTi' },
      { name: '仿宋GB2312', value: 'FangSongGB2312' },
      { name: '楷体GB2312', value: 'KaiTiGB2312' },
      { name: '俪黑 Pro', value: 'LiHei Pro Medium' },
      { name: '俪宋 Pro', value: 'LiSong Pro Light' },
      { name: '苹果俪中黑', value: 'Apple LiGothic Medium' },
      { name: '苹果俪细宋', value: 'Apple LiSung Light' },
      { name: '隶书', value: 'LiSu' },
      { name: '幼圆', value: 'YouYuan' },
      { name: '华文细黑', value: 'STXihei' },
      { name: '华文楷体', value: 'STKaiti' },
      { name: '华文宋体', value: 'STSong' },
      { name: '华文中宋', value: 'STZhongsong' },
      { name: '华文仿宋', value: 'STFangsong' },
      { name: '方正舒体', value: 'FZShuTi' },
      { name: '方正姚体', value: 'FZYaoti' },
      { name: '华文彩云', value: 'STCaiyun' },
      { name: '华文琥珀', value: 'STHupo' },
      { name: '华文隶书', value: 'STLiti' },
      { name: '华文行楷', value: 'STXingkai' },
      { name: '华文新魏', value: 'STXinwei' }
    ],
    color: db.get('COLOR', 'rgb(24, 144, 255)'),
    font: db.get('FONT', 'Mlcrosoft YaHel'),
    globalFont: db.get('GLOBALFONT', '')
  },
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      db.save('THEME', theme)
      state.theme = theme
    },
    setLayout (state, layout) {
      db.save('LAYOUT', layout)
      state.layout = layout
    },
    setMultipage (state, multipage) {
      db.save('MULTIPAGE', multipage)
      state.multipage = multipage
    },
    setSidebar (state, type) {
      state.sidebar.opened = type
    },
    fixSiderbar (state, flag) {
      db.save('FIX_SIDERBAR', flag)
      state.fixSiderbar = flag
    },
    fixHeader (state, flag) {
      db.save('FIX_HEADER', flag)
      state.fixHeader = flag
    },
    setSettingBar (state, flag) {
      state.settingBar.opened = flag
    },
    setColor (state, color) {
      db.save('COLOR', color)
      state.color = color
    },
    setFont (state, font) {
      db.save('FONT', font)
      state.font = font
    },
    setGlobalFont (state, globalFont) {
      db.save('GLOBALFONT', globalFont)
      state.globalFont = globalFont
    }
  }
}

function getBooleanValue (value, defaultValue) {
  if (Object.is(value, null)) {
    return defaultValue
  }
  if (JSON.stringify(value) !== '{}') {
    return value
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js